import { render, staticRenderFns } from "./HomeSwiper.vue?vue&type=template&id=d8f4e78e&scoped=true&"
import script from "./HomeSwiper.vue?vue&type=script&lang=js&"
export * from "./HomeSwiper.vue?vue&type=script&lang=js&"
import style0 from "./HomeSwiper.vue?vue&type=style&index=0&id=d8f4e78e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f4e78e",
  null
  
)

export default component.exports